export interface NoteGroup {
  /** A line the group hangs under, where the bullets are its consequences. */
  lead?: string
  items: string[]
}

/** The case for the agent-first framing, and the objections to the other one. */
const CAI_FIRST: NoteGroup[] = [
  {
    items: [
      'Cai is for fleet-owners, from owner-operators to large fleets.',
      'User downloads because they are curious, and gets value with just inputing a DOT number',
      'Cai can be free.',
      'User can slowly connect accounts as Cai builds trust over time.',
    ],
  },
  {
    lead: 'If we position as an AI CFO;',
    items: [
      'Have to explain what a "CFO" is to majority of customers',
      '“I don’t need that. My wife manages the books.”',
      'Finance = connecting bank accounts, user hesitation (especially around an AI tool)',
      'CFOs don’t typically manage insurance.',
      'User has demonstrated they don’t know the difference between CFO and bookkeeping.',
      'If Cai is the CFO, then what happens to the payment model?',
    ],
  },
]

function Notes({ items }: { items: string[] }) {
  return (
    <ul className="flex list-disc flex-col gap-2 pl-4">
      {items.map((note) => (
        <li key={note}>{note}</li>
      ))}
    </ul>
  )
}

/** The argument beside a line-up, in its own column. */
export function PositioningNotes({ groups = CAI_FIRST }: { groups?: NoteGroup[] }) {
  return (
    <div className="text-ink-600 flex flex-col gap-4 text-xs leading-relaxed">
      <h3 className="text-ink text-sm font-bold tracking-tight">Positioning Notes</h3>

      {groups.map((group) => (
        <div key={group.lead ?? group.items[0]}>
          {group.lead ? (
            <ul className="flex list-disc flex-col gap-2 pl-4">
              <li>
                {group.lead}
                <div className="mt-2">
                  <Notes items={group.items} />
                </div>
              </li>
            </ul>
          ) : (
            <Notes items={group.items} />
          )}
        </div>
      ))}
    </div>
  )
}
